import React from 'react'

import { Button } from '../../../main/components/button'
import { DialogBody, DialogFooter } from '../../../main/components/dialog'
import { Paragraph } from '../../../main/components/typography'

type SuccessContentProps = {
  portfolioUrl: string
  onClose?: () => void
}

export default function SuccessContent({ portfolioUrl, onClose }: SuccessContentProps) {
  return (
    <>
      <DialogBody>
        <div className="p-4 text-center">
          <Paragraph>Successfully saved to portfolio.</Paragraph>
          <Paragraph>Do you wish to proceed to the portfolio?</Paragraph>
        </div>
      </DialogBody>
      <DialogFooter>
        {onClose && <Button onClick={onClose}>Close</Button>}
        <Button as="a" href={portfolioUrl} theme="blue">
          Proceed
        </Button>
      </DialogFooter>
    </>
  )
}
